import React from 'react';

function SimpleDashboardGrid({ rooms, onRoomClick, onNavigate }) {
  // Grouper les chambres par étage
  const roomsByFloor = rooms.reduce((acc, room) => {
    if (!acc[room.floor]) {
      acc[room.floor] = [];
    }
    acc[room.floor].push(room);
    return acc;
  }, {});

  const floors = Object.keys(roomsByFloor).sort((a, b) => b - a);

  const getStatusColor = (status) => {
    switch (status) {
      case 'available': return 'var(--available-green)';
      case 'occupied': return 'var(--occupied-coral)';
      case 'reserved': return 'var(--reserved-blue)';
      case 'maintenance': return 'var(--maintenance-amber)';
      case 'cleaning': return 'var(--cleaning-amber)';
      default: return 'var(--text-muted)';
    }
  };

  const getStatusStats = () => {
    const stats = {
      available: rooms.filter(r => r.status === 'available').length,
      occupied: rooms.filter(r => r.status === 'occupied').length,
      reserved: rooms.filter(r => r.status === 'reserved').length,
      maintenance: rooms.filter(r => r.status === 'maintenance').length,
      cleaning: rooms.filter(r => r.status === 'cleaning').length,
    };
    return stats;
  };

  const stats = getStatusStats();

  return (
    <div className="simple-dashboard-grid">
      <div className="grid-header">
        <h2>📍 Aperçu des chambres</h2>
        <div className="quick-stats">
          <span className="stat-item available">{stats.available} libres</span>
          <span className="stat-item occupied">{stats.occupied} occupées</span>
          <span className="stat-item reserved">{stats.reserved} réservées</span>
          {stats.maintenance > 0 && (
            <span className="stat-item maintenance">{stats.maintenance} maintenance</span>
          )}
          {stats.cleaning > 0 && (
            <span className="stat-item cleaning">{stats.cleaning} nettoyage</span>
          )}
        </div>
      </div>

      <div className="simple-grid">
        {floors.map(floor => (
          <div key={floor} className="simple-floor">
            <div className="simple-floor-label">É{floor}</div>
            <div className="simple-floor-rooms">
              {roomsByFloor[floor]
                .sort((a, b) => a.room_number.localeCompare(b.room_number))
                .map(room => (
                  <div
                    key={room.id}
                    className={`simple-room ${room.status}`}
                    style={{
                      backgroundColor: getStatusColor(room.status),
                      opacity: room.status === 'available' ? 0.7 : 1
                    }}
                    onClick={() => onRoomClick && onRoomClick(room.id)}
                    title={`${room.room_number} - ${room.status}${room.guest_name ? ` - ${room.guest_name}` : ''}`}
                  >
                    <span className="simple-room-number">{room.room_number.slice(-2)}</span>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>

      <div className="grid-legend">
        <div className="legend-items">
          <div className="legend-item">
            <div className="legend-dot" style={{ backgroundColor: 'var(--available-green)' }}></div>
            <span>Libre</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot" style={{ backgroundColor: 'var(--occupied-coral)' }}></div>
            <span>Occupée</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot" style={{ backgroundColor: 'var(--reserved-blue)' }}></div>
            <span>Réservée</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot" style={{ backgroundColor: 'var(--maintenance-amber)' }}></div>
            <span>Maintenance</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot" style={{ backgroundColor: 'var(--cleaning-amber)' }}></div>
            <span>Nettoyage</span>
          </div>
        </div>

        <div className="grid-actions">
          <button
            className="btn btn-secondary btn-small"
            onClick={() => onNavigate && onNavigate('rooms')}
          >
            Voir détails →
          </button>
        </div>
      </div>
    </div>
  );
}

export default SimpleDashboardGrid;